export default "__VITE_ASSET__DVL5gRPX__ 288w, __VITE_ASSET__C6EA$pc3__ 432w, __VITE_ASSET__Cc3jP_lJ__ 576w";